<template>
  <v-dialog
      :value="true"
      persistent
      max-width="690"

  >
    <v-card light>
      <v-card-title class="headline">
        {{$t('views.videoupload.uploading')}}
      </v-card-title>
      <v-card-text>

        <v-container>
          <v-row align="center" justify="center">
            {{$t('views.videoupload.upload_reason')}}
          </v-row>
          <v-row align="center" justify="center" class="pt-3">
            <v-progress-linear :value="progressPerc"
                               height="8"
                               color="secondary"
                               light
            ></v-progress-linear>
          </v-row>
          <v-row align="center" justify="center" no-gutters>
            <div class="text-center caption" v-if="numberOfFiles>0"
            >{{ numberOfFiles }} {{$t('general.remaining')}}
            </div>
          </v-row>
          <v-row align="center" justify="center" no-gutters>
            <div class="text-center pt-3" v-if="isUploading && total>0"
            >{{$t('views.videoupload.uploaded_progress',{loaded,total})}}
            </div>
            <div class="text-center pt-3 error--text" v-else-if="!isUploading && numberOfFiles > 0"
            >{{$t('views.videoupload.upload_problem')}}
            </div>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            grey
            text
            @click="onCancel()"
        >
          {{$t('general.cancel')}}
        </v-btn>
        <v-btn  v-if="!isUploading && numberOfFiles > 0" color="secondary" @click="retry()">{{$t('general.tryagain')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  export default {
    name: "VideoUploading",
    props:{

    },
    components: {

    },
    computed:{
      isUploading(){
        return this.$store.state.videos.uploading;
      },
      numberOfFiles(){
        return this.$store.state.videos.list.length;
      },
      loaded(){
        return this.$store.state.videos.uploadProgress ? ((this.$store.state.videos.uploadProgress.loaded/1024)/1024).toFixed(2) : 0;
      },
      total(){
        return this.$store.state.videos.uploadProgress ? ((this.$store.state.videos.uploadProgress.total)/1024/1024).toFixed(2) : 0;
      },
      progressPerc(){
        const p=this.$store.state.videos.uploadProgress;
        if(!p){
          return 0;
        }
        return (p.loaded || 0)/(p.total || 1)*100;
      }
    },
    methods:{
       retry(){
         this.$store.dispatch('videos/startQueueUploading');
       },
       onComplete(){
         clearInterval(this.checkCompleteInterval);
         return this.$emit('complete');
       },
      onCancel(){
        clearInterval(this.checkCompleteInterval)
        this.$store.dispatch('videos/stopQueueUploading');
        return this.$emit('cancel');
      }
    },
    mounted() {
     setTimeout(()=>{
       this.checkCompleteInterval = setInterval(()=>{
         if(this.numberOfFiles===0){
           clearInterval(this.checkCompleteInterval)
           this.onComplete();
         }
       },500);
     },1000);
    },
    beforeDestroy() {
      clearInterval(this.checkCompleteInterval)
    }
  }
</script>

<style scoped>

</style>